import PropTypes from 'prop-types';
import React from 'react';
import ClickOutside from 'react-onclickoutside';

class Toggle extends React.Component {
	render() {
		return (
			<div className="toggle-wrap">
				<div className="toggle-wrap__head">{ this.props.head }</div>
				{ this.props.isShow && (
					<div className="toggle-wrap__body">{ this.props.children }</div>
				) }
			</div>
		);
	}

	handleClickOutside(e) {
		if (this.props.isShow && this.props.onOutSideClick) {
			this.props.onOutSideClick();
		}
	}
}

Toggle.propTypes = {
	head: PropTypes.element.isRequired,
	children: PropTypes.element.isRequired,
	isShow: PropTypes.bool,
	onOutSideClick: PropTypes.func
};

export default ClickOutside(Toggle);




// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/toggle.js